import React, { createContext, useContext, useState } from "react";
import { Filters, Product } from "./types";


type HomeState = {
  products: Product[];
  setProducts: React.Dispatch<React.SetStateAction<Product[]>>;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  compareIds: number[];
  setCompareIds: React.Dispatch<React.SetStateAction<number[]>>;
};

const HomeContext = createContext<HomeState | undefined>(undefined);

export const useHomeContext = () => {
  const ctx = useContext(HomeContext);
  if (!ctx) throw new Error("useHomeContext must be used within HomeProvider");
  return ctx;
};

export const HomeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [filters, setFilters] = useState<Filters>({
    name: '',
    brand: '',
    categoryId: '',
    gender: '',
    retailer: '',
    minPrice: '',
    maxPrice: '',
  });
  const [page, setPage] = useState(1);
  const [compareIds, setCompareIds] = useState<number[]>([]);

  return (
    <HomeContext.Provider value={{
      products, setProducts, filters, setFilters, page, setPage, compareIds, setCompareIds
    }}>
      {children}
    </HomeContext.Provider>
  );
};